import { jsxs, jsx } from "react/jsx-runtime";
import { Box, Inline, ButtonLink } from "braid-design-system";
import { useLink } from "../../../ApacCandidateFooter/components/Accordion/Accordion.mjs";
import { DropdownMenu } from "../../ApacCandidateHeader.mjs";
import { root } from "./AuthLinks.css.mjs";
const AuthLinks = ({ authItems }) => {
  const { sendLinkEvent, injectLinkContextToData } = useLink();
  if (!authItems) {
    return null;
  }
  return /* @__PURE__ */ jsxs(
    Box,
    {
      className: root,
      height: "full",
      display: "flex",
      "data-automation": "sign-in-register",
      children: [
        authItems.objectType === "AuthNonMemberItem" && /* @__PURE__ */ jsx(Box, { height: "full", flexWrap: "nowrap", display: "flex", alignItems: "center", children: /* @__PURE__ */ jsx(Inline, { space: "small", children: authItems.child.map((item, index) => /* @__PURE__ */ jsx(
          ButtonLink,
          {
            variant: "ghost",
            tone: "formAccent",
            size: "small",
            href: item.href,
            onClick: () => {
              sendLinkEvent({
                linkContext: item.linkContext
              });
            },
            data: injectLinkContextToData(item.linkContext, {
              automation: item.linkContext.source
            }),
            title: item.text,
            rel: "nofollow",
            children: item.text
          },
          `buttonLink_${index}`
        )) }) }),
        authItems.objectType === "TabItemWithChild" && /* @__PURE__ */ jsx(
          DropdownMenu,
          {
            label: authItems.text,
            onExpendCollapseLinkContextData: authItems.linkContext,
            items: authItems.child,
            width: "medium",
            shouldApplyIconForActiveItem: authItems.shouldApplyIconForActiveItem
          }
        )
      ]
    }
  );
};
export {
  AuthLinks
};
